























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast, Dialog } from "vant";
import axios from "axios";
import detailCom from "@/components/estate/detailCom.vue";
const estateModule = namespace("estate");

@Component({
  components: { detailCom }
})
export default class Info extends Vue {
  @estateModule.State("estateDetail") estateDetail!: any;
  popupShow: boolean = false;
  popupList: any = [
    { name: "退回", value: 1 },
    { name: "转派", value: 2 },
    { name: "完成", value: 3 },
    { name: "取消", value: 4 }
  ];
  mounted() {
    this.getEstateDetail();
  }
  /**获取详情 */
  async getEstateDetail() {
    const { success } = await this.$store.dispatch("estate/getEstateDetail", {
      id: this.$route.query.id
    });
  }
  /**工单处理*/
  handleAssignClick(type: number) {
    this.popupShow = true;
  }
  poupClick(val: any) {
    switch (val) {
      case 1:
        // 退回
        Dialog.confirm({
          title: "工单退回",
          message: "此工单不属于业务范围内"
        })
          .then(() => {
            this.estateMaintainGoback();
          })
          .catch(() => {
            this.popupShow = false;
          });
        break;
      // 转派
      case 2:
        this.$router.push({
          path: "/estateWorker/assign",
          query: {
            id: this.$route.query.id,
            time: this.estateDetail.expectedTime
          }
        });
        break;
      // 完成
      case 3:
        this.$router.push({
          path: "/estateWorker/repair",
          query: { id: this.$route.query.id }
        });
        break;
      // 取消
      case 4:
        this.popupShow = false;
        break;
    }
  }
  //工单退回接口
  async estateMaintainGoback() {
    const { error, success } = await this.$store.dispatch(
      "estate/estateMaintainGoback",
      {
        id: this.$route.query.id
      }
    );
    if (success) {
      Toast("工单已退回");
      this.popupShow = false;
      this.$router.push("/estateWorker");
    }
    if (error) {
      Toast(error.msg);
    }
  }
}
